(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5d6e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5d6e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kGdfk", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $f0e201575aab3fee$export$a143d493d941bafc; }, function (v) { return $f0e201575aab3fee$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $f0e201575aab3fee$export$f99ded8fe4b79145; }, function (v) { return $f0e201575aab3fee$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $f0e201575aab3fee$export$a143d493d941bafc;
var $f0e201575aab3fee$export$e4cf37d7f6fb9e0a;
var $f0e201575aab3fee$export$f99ded8fe4b79145;
var $f0e201575aab3fee$export$599f31c3813fae4d;
"use strict";

var $6nV5F = parcelRequire("6nV5F");

var $eIntn = parcelRequire("eIntn");
const $f0e201575aab3fee$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$f0e201575aab3fee$export$a143d493d941bafc = $f0e201575aab3fee$var$Buffer;
$f0e201575aab3fee$export$e4cf37d7f6fb9e0a = $f0e201575aab3fee$var$SlowBuffer;
$f0e201575aab3fee$export$f99ded8fe4b79145 = 50;
const $f0e201575aab3fee$var$K_MAX_LENGTH = 0x7fffffff;
$f0e201575aab3fee$export$599f31c3813fae4d = $f0e201575aab3fee$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $f0e201575aab3fee$var$Buffer.TYPED_ARRAY_SUPPORT = $f0e201575aab3fee$var$typedArraySupport();
if (!$f0e201575aab3fee$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $f0e201575aab3fee$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($f0e201575aab3fee$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$f0e201575aab3fee$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($f0e201575aab3fee$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$f0e201575aab3fee$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $f0e201575aab3fee$var$createBuffer(length) {
    if (length > $f0e201575aab3fee$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $f0e201575aab3fee$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $f0e201575aab3fee$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $f0e201575aab3fee$var$allocUnsafe(arg);
    }
    return $f0e201575aab3fee$var$from(arg, encodingOrOffset, length);
}
$f0e201575aab3fee$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $f0e201575aab3fee$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $f0e201575aab3fee$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $f0e201575aab3fee$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($f0e201575aab3fee$var$isInstance(value, ArrayBuffer) || value && $f0e201575aab3fee$var$isInstance(value.buffer, ArrayBuffer)) return $f0e201575aab3fee$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($f0e201575aab3fee$var$isInstance(value, SharedArrayBuffer) || value && $f0e201575aab3fee$var$isInstance(value.buffer, SharedArrayBuffer))) return $f0e201575aab3fee$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $f0e201575aab3fee$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $f0e201575aab3fee$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $f0e201575aab3fee$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $f0e201575aab3fee$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $f0e201575aab3fee$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($f0e201575aab3fee$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($f0e201575aab3fee$var$Buffer, Uint8Array);
function $f0e201575aab3fee$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $f0e201575aab3fee$var$alloc(size, fill, encoding) {
    $f0e201575aab3fee$var$assertSize(size);
    if (size <= 0) return $f0e201575aab3fee$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $f0e201575aab3fee$var$createBuffer(size).fill(fill, encoding) : $f0e201575aab3fee$var$createBuffer(size).fill(fill);
    return $f0e201575aab3fee$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $f0e201575aab3fee$var$Buffer.alloc = function(size, fill, encoding) {
    return $f0e201575aab3fee$var$alloc(size, fill, encoding);
};
function $f0e201575aab3fee$var$allocUnsafe(size) {
    $f0e201575aab3fee$var$assertSize(size);
    return $f0e201575aab3fee$var$createBuffer(size < 0 ? 0 : $f0e201575aab3fee$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $f0e201575aab3fee$var$Buffer.allocUnsafe = function(size) {
    return $f0e201575aab3fee$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $f0e201575aab3fee$var$Buffer.allocUnsafeSlow = function(size) {
    return $f0e201575aab3fee$var$allocUnsafe(size);
};
function $f0e201575aab3fee$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$f0e201575aab3fee$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $f0e201575aab3fee$var$byteLength(string, encoding) | 0;
    let buf = $f0e201575aab3fee$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $f0e201575aab3fee$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $f0e201575aab3fee$var$checked(array.length) | 0;
    const buf = $f0e201575aab3fee$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $f0e201575aab3fee$var$fromArrayView(arrayView) {
    if ($f0e201575aab3fee$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $f0e201575aab3fee$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $f0e201575aab3fee$var$fromArrayLike(arrayView);
}
function $f0e201575aab3fee$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $f0e201575aab3fee$var$Buffer.prototype);
    return buf;
}
function $f0e201575aab3fee$var$fromObject(obj) {
    if ($f0e201575aab3fee$var$Buffer.isBuffer(obj)) {
        const len = $f0e201575aab3fee$var$checked(obj.length) | 0;
        const buf = $f0e201575aab3fee$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $f0e201575aab3fee$var$numberIsNaN(obj.length)) return $f0e201575aab3fee$var$createBuffer(0);
        return $f0e201575aab3fee$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $f0e201575aab3fee$var$fromArrayLike(obj.data);
}
function $f0e201575aab3fee$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $f0e201575aab3fee$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $f0e201575aab3fee$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $f0e201575aab3fee$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $f0e201575aab3fee$var$Buffer.alloc(+length);
}
$f0e201575aab3fee$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $f0e201575aab3fee$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$f0e201575aab3fee$var$Buffer.compare = function compare(a, b) {
    if ($f0e201575aab3fee$var$isInstance(a, Uint8Array)) a = $f0e201575aab3fee$var$Buffer.from(a, a.offset, a.byteLength);
    if ($f0e201575aab3fee$var$isInstance(b, Uint8Array)) b = $f0e201575aab3fee$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$f0e201575aab3fee$var$Buffer.isBuffer(a) || !$f0e201575aab3fee$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$f0e201575aab3fee$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$f0e201575aab3fee$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $f0e201575aab3fee$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $f0e201575aab3fee$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($f0e201575aab3fee$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$f0e201575aab3fee$var$Buffer.isBuffer(buf)) buf = $f0e201575aab3fee$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$f0e201575aab3fee$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $f0e201575aab3fee$var$byteLength(string, encoding) {
    if ($f0e201575aab3fee$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $f0e201575aab3fee$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $f0e201575aab3fee$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $f0e201575aab3fee$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $f0e201575aab3fee$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$f0e201575aab3fee$var$Buffer.byteLength = $f0e201575aab3fee$var$byteLength;
function $f0e201575aab3fee$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $f0e201575aab3fee$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $f0e201575aab3fee$var$utf8Slice(this, start, end);
        case "ascii":
            return $f0e201575aab3fee$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $f0e201575aab3fee$var$latin1Slice(this, start, end);
        case "base64":
            return $f0e201575aab3fee$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $f0e201575aab3fee$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$f0e201575aab3fee$var$Buffer.prototype._isBuffer = true;
function $f0e201575aab3fee$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$f0e201575aab3fee$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$f0e201575aab3fee$var$swap(this, i, i + 1);
    return this;
};
$f0e201575aab3fee$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $f0e201575aab3fee$var$swap(this, i, i + 3);
        $f0e201575aab3fee$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$f0e201575aab3fee$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $f0e201575aab3fee$var$swap(this, i, i + 7);
        $f0e201575aab3fee$var$swap(this, i + 1, i + 6);
        $f0e201575aab3fee$var$swap(this, i + 2, i + 5);
        $f0e201575aab3fee$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$f0e201575aab3fee$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $f0e201575aab3fee$var$utf8Slice(this, 0, length);
    return $f0e201575aab3fee$var$slowToString.apply(this, arguments);
};
$f0e201575aab3fee$var$Buffer.prototype.toLocaleString = $f0e201575aab3fee$var$Buffer.prototype.toString;
$f0e201575aab3fee$var$Buffer.prototype.equals = function equals(b) {
    if (!$f0e201575aab3fee$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $f0e201575aab3fee$var$Buffer.compare(this, b) === 0;
};
$f0e201575aab3fee$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $f0e201575aab3fee$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($f0e201575aab3fee$var$customInspectSymbol) $f0e201575aab3fee$var$Buffer.prototype[$f0e201575aab3fee$var$customInspectSymbol] = $f0e201575aab3fee$var$Buffer.prototype.inspect;
$f0e201575aab3fee$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($f0e201575aab3fee$var$isInstance(target, Uint8Array)) target = $f0e201575aab3fee$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$f0e201575aab3fee$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $f0e201575aab3fee$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($f0e201575aab3fee$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $f0e201575aab3fee$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($f0e201575aab3fee$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $f0e201575aab3fee$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $f0e201575aab3fee$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $f0e201575aab3fee$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$f0e201575aab3fee$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$f0e201575aab3fee$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $f0e201575aab3fee$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$f0e201575aab3fee$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $f0e201575aab3fee$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $f0e201575aab3fee$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($f0e201575aab3fee$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $f0e201575aab3fee$var$utf8Write(buf, string, offset, length) {
    return $f0e201575aab3fee$var$blitBuffer($f0e201575aab3fee$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $f0e201575aab3fee$var$asciiWrite(buf, string, offset, length) {
    return $f0e201575aab3fee$var$blitBuffer($f0e201575aab3fee$var$asciiToBytes(string), buf, offset, length);
}
function $f0e201575aab3fee$var$base64Write(buf, string, offset, length) {
    return $f0e201575aab3fee$var$blitBuffer($f0e201575aab3fee$var$base64ToBytes(string), buf, offset, length);
}
function $f0e201575aab3fee$var$ucs2Write(buf, string, offset, length) {
    return $f0e201575aab3fee$var$blitBuffer($f0e201575aab3fee$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$f0e201575aab3fee$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $f0e201575aab3fee$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $f0e201575aab3fee$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $f0e201575aab3fee$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $f0e201575aab3fee$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $f0e201575aab3fee$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$f0e201575aab3fee$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $f0e201575aab3fee$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $6nV5F.fromByteArray(buf);
    else return $6nV5F.fromByteArray(buf.slice(start, end));
}
function $f0e201575aab3fee$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $f0e201575aab3fee$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $f0e201575aab3fee$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $f0e201575aab3fee$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $f0e201575aab3fee$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $f0e201575aab3fee$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $f0e201575aab3fee$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $f0e201575aab3fee$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $f0e201575aab3fee$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $f0e201575aab3fee$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $f0e201575aab3fee$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$f0e201575aab3fee$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $f0e201575aab3fee$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $f0e201575aab3fee$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$f0e201575aab3fee$var$Buffer.prototype.readUintLE = $f0e201575aab3fee$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $f0e201575aab3fee$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$f0e201575aab3fee$var$Buffer.prototype.readUintBE = $f0e201575aab3fee$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $f0e201575aab3fee$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$f0e201575aab3fee$var$Buffer.prototype.readUint8 = $f0e201575aab3fee$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f0e201575aab3fee$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$f0e201575aab3fee$var$Buffer.prototype.readUint16LE = $f0e201575aab3fee$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f0e201575aab3fee$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$f0e201575aab3fee$var$Buffer.prototype.readUint16BE = $f0e201575aab3fee$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f0e201575aab3fee$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$f0e201575aab3fee$var$Buffer.prototype.readUint32LE = $f0e201575aab3fee$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f0e201575aab3fee$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$f0e201575aab3fee$var$Buffer.prototype.readUint32BE = $f0e201575aab3fee$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f0e201575aab3fee$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$f0e201575aab3fee$var$Buffer.prototype.readBigUInt64LE = $f0e201575aab3fee$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $f0e201575aab3fee$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $f0e201575aab3fee$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$f0e201575aab3fee$var$Buffer.prototype.readBigUInt64BE = $f0e201575aab3fee$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $f0e201575aab3fee$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $f0e201575aab3fee$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$f0e201575aab3fee$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $f0e201575aab3fee$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$f0e201575aab3fee$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $f0e201575aab3fee$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$f0e201575aab3fee$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f0e201575aab3fee$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$f0e201575aab3fee$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f0e201575aab3fee$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$f0e201575aab3fee$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f0e201575aab3fee$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$f0e201575aab3fee$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f0e201575aab3fee$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$f0e201575aab3fee$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f0e201575aab3fee$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$f0e201575aab3fee$var$Buffer.prototype.readBigInt64LE = $f0e201575aab3fee$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $f0e201575aab3fee$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $f0e201575aab3fee$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$f0e201575aab3fee$var$Buffer.prototype.readBigInt64BE = $f0e201575aab3fee$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $f0e201575aab3fee$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $f0e201575aab3fee$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$f0e201575aab3fee$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f0e201575aab3fee$var$checkOffset(offset, 4, this.length);
    return $eIntn.read(this, offset, true, 23, 4);
};
$f0e201575aab3fee$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f0e201575aab3fee$var$checkOffset(offset, 4, this.length);
    return $eIntn.read(this, offset, false, 23, 4);
};
$f0e201575aab3fee$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f0e201575aab3fee$var$checkOffset(offset, 8, this.length);
    return $eIntn.read(this, offset, true, 52, 8);
};
$f0e201575aab3fee$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f0e201575aab3fee$var$checkOffset(offset, 8, this.length);
    return $eIntn.read(this, offset, false, 52, 8);
};
function $f0e201575aab3fee$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$f0e201575aab3fee$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$f0e201575aab3fee$var$Buffer.prototype.writeUintLE = $f0e201575aab3fee$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $f0e201575aab3fee$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$f0e201575aab3fee$var$Buffer.prototype.writeUintBE = $f0e201575aab3fee$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $f0e201575aab3fee$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$f0e201575aab3fee$var$Buffer.prototype.writeUint8 = $f0e201575aab3fee$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f0e201575aab3fee$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$f0e201575aab3fee$var$Buffer.prototype.writeUint16LE = $f0e201575aab3fee$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f0e201575aab3fee$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$f0e201575aab3fee$var$Buffer.prototype.writeUint16BE = $f0e201575aab3fee$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f0e201575aab3fee$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$f0e201575aab3fee$var$Buffer.prototype.writeUint32LE = $f0e201575aab3fee$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f0e201575aab3fee$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$f0e201575aab3fee$var$Buffer.prototype.writeUint32BE = $f0e201575aab3fee$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f0e201575aab3fee$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $f0e201575aab3fee$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $f0e201575aab3fee$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $f0e201575aab3fee$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $f0e201575aab3fee$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$f0e201575aab3fee$var$Buffer.prototype.writeBigUInt64LE = $f0e201575aab3fee$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $f0e201575aab3fee$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$f0e201575aab3fee$var$Buffer.prototype.writeBigUInt64BE = $f0e201575aab3fee$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $f0e201575aab3fee$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$f0e201575aab3fee$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $f0e201575aab3fee$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$f0e201575aab3fee$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $f0e201575aab3fee$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$f0e201575aab3fee$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f0e201575aab3fee$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$f0e201575aab3fee$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f0e201575aab3fee$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$f0e201575aab3fee$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f0e201575aab3fee$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$f0e201575aab3fee$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f0e201575aab3fee$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$f0e201575aab3fee$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f0e201575aab3fee$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$f0e201575aab3fee$var$Buffer.prototype.writeBigInt64LE = $f0e201575aab3fee$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $f0e201575aab3fee$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$f0e201575aab3fee$var$Buffer.prototype.writeBigInt64BE = $f0e201575aab3fee$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $f0e201575aab3fee$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $f0e201575aab3fee$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $f0e201575aab3fee$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f0e201575aab3fee$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $eIntn.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$f0e201575aab3fee$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $f0e201575aab3fee$var$writeFloat(this, value, offset, true, noAssert);
};
$f0e201575aab3fee$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $f0e201575aab3fee$var$writeFloat(this, value, offset, false, noAssert);
};
function $f0e201575aab3fee$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f0e201575aab3fee$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $eIntn.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$f0e201575aab3fee$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $f0e201575aab3fee$var$writeDouble(this, value, offset, true, noAssert);
};
$f0e201575aab3fee$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $f0e201575aab3fee$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$f0e201575aab3fee$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$f0e201575aab3fee$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$f0e201575aab3fee$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$f0e201575aab3fee$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $f0e201575aab3fee$var$Buffer.isBuffer(val) ? val : $f0e201575aab3fee$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $f0e201575aab3fee$var$errors = {};
function $f0e201575aab3fee$var$E(sym, getMessage, Base) {
    $f0e201575aab3fee$var$errors[sym] = class NodeError extends Base {
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
    };
}
$f0e201575aab3fee$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$f0e201575aab3fee$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$f0e201575aab3fee$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $f0e201575aab3fee$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $f0e201575aab3fee$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $f0e201575aab3fee$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $f0e201575aab3fee$var$checkBounds(buf, offset, byteLength) {
    $f0e201575aab3fee$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $f0e201575aab3fee$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $f0e201575aab3fee$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $f0e201575aab3fee$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $f0e201575aab3fee$var$checkBounds(buf, offset, byteLength);
}
function $f0e201575aab3fee$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $f0e201575aab3fee$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $f0e201575aab3fee$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $f0e201575aab3fee$var$validateNumber(value, type);
        throw new $f0e201575aab3fee$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $f0e201575aab3fee$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $f0e201575aab3fee$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $f0e201575aab3fee$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $f0e201575aab3fee$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($f0e201575aab3fee$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $f0e201575aab3fee$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $f0e201575aab3fee$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $f0e201575aab3fee$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $f0e201575aab3fee$var$base64ToBytes(str) {
    return $6nV5F.toByteArray($f0e201575aab3fee$var$base64clean(str));
}
function $f0e201575aab3fee$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $f0e201575aab3fee$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $f0e201575aab3fee$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $f0e201575aab3fee$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $f0e201575aab3fee$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $f0e201575aab3fee$var$BufferBigIntNotDefined : fn;
}
function $f0e201575aab3fee$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRegister("6nV5F", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $4a612d0237ddada4$export$d622b2ad8d90c771; }, function (v) { return $4a612d0237ddada4$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $4a612d0237ddada4$export$6100ba28696e12de; }, function (v) { return $4a612d0237ddada4$export$6100ba28696e12de = v; });
var $4a612d0237ddada4$export$a48f0734ac7c2329;
var $4a612d0237ddada4$export$d622b2ad8d90c771;
var $4a612d0237ddada4$export$6100ba28696e12de;
"use strict";
$4a612d0237ddada4$export$a48f0734ac7c2329 = $4a612d0237ddada4$var$byteLength;
$4a612d0237ddada4$export$d622b2ad8d90c771 = $4a612d0237ddada4$var$toByteArray;
$4a612d0237ddada4$export$6100ba28696e12de = $4a612d0237ddada4$var$fromByteArray;
var $4a612d0237ddada4$var$lookup = [];
var $4a612d0237ddada4$var$revLookup = [];
var $4a612d0237ddada4$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $4a612d0237ddada4$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $4a612d0237ddada4$var$i = 0, $4a612d0237ddada4$var$len = $4a612d0237ddada4$var$code.length; $4a612d0237ddada4$var$i < $4a612d0237ddada4$var$len; ++$4a612d0237ddada4$var$i){
    $4a612d0237ddada4$var$lookup[$4a612d0237ddada4$var$i] = $4a612d0237ddada4$var$code[$4a612d0237ddada4$var$i];
    $4a612d0237ddada4$var$revLookup[$4a612d0237ddada4$var$code.charCodeAt($4a612d0237ddada4$var$i)] = $4a612d0237ddada4$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$4a612d0237ddada4$var$revLookup["-".charCodeAt(0)] = 62;
$4a612d0237ddada4$var$revLookup["_".charCodeAt(0)] = 63;
function $4a612d0237ddada4$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $4a612d0237ddada4$var$byteLength(b64) {
    var lens = $4a612d0237ddada4$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $4a612d0237ddada4$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $4a612d0237ddada4$var$toByteArray(b64) {
    var tmp;
    var lens = $4a612d0237ddada4$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $4a612d0237ddada4$var$Arr($4a612d0237ddada4$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $4a612d0237ddada4$var$revLookup[b64.charCodeAt(i)] << 18 | $4a612d0237ddada4$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $4a612d0237ddada4$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $4a612d0237ddada4$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $4a612d0237ddada4$var$revLookup[b64.charCodeAt(i)] << 2 | $4a612d0237ddada4$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $4a612d0237ddada4$var$revLookup[b64.charCodeAt(i)] << 10 | $4a612d0237ddada4$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $4a612d0237ddada4$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $4a612d0237ddada4$var$tripletToBase64(num) {
    return $4a612d0237ddada4$var$lookup[num >> 18 & 0x3F] + $4a612d0237ddada4$var$lookup[num >> 12 & 0x3F] + $4a612d0237ddada4$var$lookup[num >> 6 & 0x3F] + $4a612d0237ddada4$var$lookup[num & 0x3F];
}
function $4a612d0237ddada4$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($4a612d0237ddada4$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $4a612d0237ddada4$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($4a612d0237ddada4$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($4a612d0237ddada4$var$lookup[tmp >> 2] + $4a612d0237ddada4$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($4a612d0237ddada4$var$lookup[tmp >> 10] + $4a612d0237ddada4$var$lookup[tmp >> 4 & 0x3F] + $4a612d0237ddada4$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("eIntn", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $ab6761f748358c06$export$aafa59e2e03f2942; }, function (v) { return $ab6761f748358c06$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $ab6761f748358c06$export$68d8715fc104d294; }, function (v) { return $ab6761f748358c06$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $ab6761f748358c06$export$aafa59e2e03f2942;
var $ab6761f748358c06$export$68d8715fc104d294;
$ab6761f748358c06$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$ab6761f748358c06$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


var $fdfecf3dc192a989$exports = {};
// shim for using process in browser
var $fdfecf3dc192a989$var$process = $fdfecf3dc192a989$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $fdfecf3dc192a989$var$cachedSetTimeout;
var $fdfecf3dc192a989$var$cachedClearTimeout;
function $fdfecf3dc192a989$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $fdfecf3dc192a989$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $fdfecf3dc192a989$var$cachedSetTimeout = setTimeout;
        else $fdfecf3dc192a989$var$cachedSetTimeout = $fdfecf3dc192a989$var$defaultSetTimout;
    } catch (e) {
        $fdfecf3dc192a989$var$cachedSetTimeout = $fdfecf3dc192a989$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $fdfecf3dc192a989$var$cachedClearTimeout = clearTimeout;
        else $fdfecf3dc192a989$var$cachedClearTimeout = $fdfecf3dc192a989$var$defaultClearTimeout;
    } catch (e) {
        $fdfecf3dc192a989$var$cachedClearTimeout = $fdfecf3dc192a989$var$defaultClearTimeout;
    }
})();
function $fdfecf3dc192a989$var$runTimeout(fun) {
    if ($fdfecf3dc192a989$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($fdfecf3dc192a989$var$cachedSetTimeout === $fdfecf3dc192a989$var$defaultSetTimout || !$fdfecf3dc192a989$var$cachedSetTimeout) && setTimeout) {
        $fdfecf3dc192a989$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $fdfecf3dc192a989$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $fdfecf3dc192a989$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $fdfecf3dc192a989$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $fdfecf3dc192a989$var$runClearTimeout(marker) {
    if ($fdfecf3dc192a989$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($fdfecf3dc192a989$var$cachedClearTimeout === $fdfecf3dc192a989$var$defaultClearTimeout || !$fdfecf3dc192a989$var$cachedClearTimeout) && clearTimeout) {
        $fdfecf3dc192a989$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $fdfecf3dc192a989$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $fdfecf3dc192a989$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $fdfecf3dc192a989$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $fdfecf3dc192a989$var$queue = [];
var $fdfecf3dc192a989$var$draining = false;
var $fdfecf3dc192a989$var$currentQueue;
var $fdfecf3dc192a989$var$queueIndex = -1;
function $fdfecf3dc192a989$var$cleanUpNextTick() {
    if (!$fdfecf3dc192a989$var$draining || !$fdfecf3dc192a989$var$currentQueue) return;
    $fdfecf3dc192a989$var$draining = false;
    if ($fdfecf3dc192a989$var$currentQueue.length) $fdfecf3dc192a989$var$queue = $fdfecf3dc192a989$var$currentQueue.concat($fdfecf3dc192a989$var$queue);
    else $fdfecf3dc192a989$var$queueIndex = -1;
    if ($fdfecf3dc192a989$var$queue.length) $fdfecf3dc192a989$var$drainQueue();
}
function $fdfecf3dc192a989$var$drainQueue() {
    if ($fdfecf3dc192a989$var$draining) return;
    var timeout = $fdfecf3dc192a989$var$runTimeout($fdfecf3dc192a989$var$cleanUpNextTick);
    $fdfecf3dc192a989$var$draining = true;
    var len = $fdfecf3dc192a989$var$queue.length;
    while(len){
        $fdfecf3dc192a989$var$currentQueue = $fdfecf3dc192a989$var$queue;
        $fdfecf3dc192a989$var$queue = [];
        while(++$fdfecf3dc192a989$var$queueIndex < len)if ($fdfecf3dc192a989$var$currentQueue) $fdfecf3dc192a989$var$currentQueue[$fdfecf3dc192a989$var$queueIndex].run();
        $fdfecf3dc192a989$var$queueIndex = -1;
        len = $fdfecf3dc192a989$var$queue.length;
    }
    $fdfecf3dc192a989$var$currentQueue = null;
    $fdfecf3dc192a989$var$draining = false;
    $fdfecf3dc192a989$var$runClearTimeout(timeout);
}
$fdfecf3dc192a989$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $fdfecf3dc192a989$var$queue.push(new $fdfecf3dc192a989$var$Item(fun, args));
    if ($fdfecf3dc192a989$var$queue.length === 1 && !$fdfecf3dc192a989$var$draining) $fdfecf3dc192a989$var$runTimeout($fdfecf3dc192a989$var$drainQueue);
};
// v8 likes predictible objects
function $fdfecf3dc192a989$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$fdfecf3dc192a989$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$fdfecf3dc192a989$var$process.title = "browser";
$fdfecf3dc192a989$var$process.browser = true;
$fdfecf3dc192a989$var$process.env = {};
$fdfecf3dc192a989$var$process.argv = [];
$fdfecf3dc192a989$var$process.version = ""; // empty string to avoid regexp issues
$fdfecf3dc192a989$var$process.versions = {};
function $fdfecf3dc192a989$var$noop() {}
$fdfecf3dc192a989$var$process.on = $fdfecf3dc192a989$var$noop;
$fdfecf3dc192a989$var$process.addListener = $fdfecf3dc192a989$var$noop;
$fdfecf3dc192a989$var$process.once = $fdfecf3dc192a989$var$noop;
$fdfecf3dc192a989$var$process.off = $fdfecf3dc192a989$var$noop;
$fdfecf3dc192a989$var$process.removeListener = $fdfecf3dc192a989$var$noop;
$fdfecf3dc192a989$var$process.removeAllListeners = $fdfecf3dc192a989$var$noop;
$fdfecf3dc192a989$var$process.emit = $fdfecf3dc192a989$var$noop;
$fdfecf3dc192a989$var$process.prependListener = $fdfecf3dc192a989$var$noop;
$fdfecf3dc192a989$var$process.prependOnceListener = $fdfecf3dc192a989$var$noop;
$fdfecf3dc192a989$var$process.listeners = function(name) {
    return [];
};
$fdfecf3dc192a989$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$fdfecf3dc192a989$var$process.cwd = function() {
    return "/";
};
$fdfecf3dc192a989$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$fdfecf3dc192a989$var$process.umask = function() {
    return 0;
};



var $kGdfk = parcelRequire("kGdfk");
var $30f48e7c7d6109f3$require$Buffer = $kGdfk.Buffer;
var $30f48e7c7d6109f3$var$error_logger = function(j) {
    "use strict";
    class et {
        subscribe(t) {
            return this._observers.add(t), this._messagesHistory.forEach((n)=>t(n)), {
                unsubscribe: ()=>this.unsubscribe(t)
            };
        }
        unsubscribe(t) {
            this._observers.delete(t);
        }
        notify(t) {
            this._messagesHistory.push(t), this._observers.forEach((n)=>n(t));
        }
        constructor(){
            this._observers = new Set, this._messagesHistory = [];
        }
    }
    function tt(e, t) {
        return function(...n) {
            const r = Date.now();
            var _e_lastCall;
            if (!(r - ((_e_lastCall = e.lastCall) !== null && _e_lastCall !== void 0 ? _e_lastCall : 0) < t)) return e.lastCall = r, e(...n);
        };
    }
    function he(e, t) {
        return function() {
            return e.apply(t, arguments);
        };
    }
    const { toString: nt } = Object.prototype, { getPrototypeOf: te } = Object, J = ((e)=>(t)=>{
            const n = nt.call(t);
            return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
        })(Object.create(null)), C = (e)=>(e = e.toLowerCase(), (t)=>J(t) === e), W = (e)=>(t)=>typeof t === e, { isArray: B } = Array, q = W("undefined");
    function rt(e) {
        return e !== null && !q(e) && e.constructor !== null && !q(e.constructor) && x(e.constructor.isBuffer) && e.constructor.isBuffer(e);
    }
    const me = C("ArrayBuffer");
    function st(e) {
        let t;
        return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && me(e.buffer), t;
    }
    const ot = W("string"), x = W("function"), ye = W("number"), $ = (e)=>e !== null && typeof e == "object", it = (e)=>e === !0 || e === !1, v = (e)=>{
        if (J(e) !== "object") return !1;
        const t = te(e);
        return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
    }, at = C("Date"), ct = C("File"), ut = C("Blob"), lt = C("FileList"), ft = (e)=>$(e) && x(e.pipe), dt = (e)=>{
        let t;
        return e && (typeof FormData == "function" && e instanceof FormData || x(e.append) && ((t = J(e)) === "formdata" || t === "object" && x(e.toString) && e.toString() === "[object FormData]"));
    }, pt = C("URLSearchParams"), [ht, mt, yt, bt] = [
        "ReadableStream",
        "Request",
        "Response",
        "Headers"
    ].map(C), wt = (e)=>e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
    function H(e, t, { allOwnKeys: n = !1 } = {}) {
        if (e === null || typeof e > "u") return;
        let r, s;
        if (typeof e != "object" && (e = [
            e
        ]), B(e)) for(r = 0, s = e.length; r < s; r++)t.call(null, e[r], r, e);
        else {
            const o = n ? Object.getOwnPropertyNames(e) : Object.keys(e), i = o.length;
            let c;
            for(r = 0; r < i; r++)c = o[r], t.call(null, e[c], c, e);
        }
    }
    function be(e, t) {
        t = t.toLowerCase();
        const n = Object.keys(e);
        let r = n.length, s;
        for(; r-- > 0;)if (s = n[r], t === s.toLowerCase()) return s;
        return null;
    }
    const _ = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : $parcel$global, we = (e)=>!q(e) && e !== _;
    function ne() {
        const { caseless: e } = we(this) && this || {}, t = {}, n = (r, s)=>{
            const o = e && be(t, s) || s;
            v(t[o]) && v(r) ? t[o] = ne(t[o], r) : v(r) ? t[o] = ne({}, r) : B(r) ? t[o] = r.slice() : t[o] = r;
        };
        for(let r = 0, s = arguments.length; r < s; r++)arguments[r] && H(arguments[r], n);
        return t;
    }
    const gt = (e, t, n, { allOwnKeys: r } = {})=>(H(t, (s, o)=>{
            n && x(s) ? e[o] = he(s, n) : e[o] = s;
        }, {
            allOwnKeys: r
        }), e), Et = (e)=>(e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), Rt = (e, t, n, r)=>{
        e.prototype = Object.create(t.prototype, r), e.prototype.constructor = e, Object.defineProperty(e, "super", {
            value: t.prototype
        }), n && Object.assign(e.prototype, n);
    }, St = (e, t, n, r)=>{
        let s, o, i;
        const c = {};
        if (t = t || {}, e == null) return t;
        do {
            for(s = Object.getOwnPropertyNames(e), o = s.length; o-- > 0;)i = s[o], (!r || r(i, e, t)) && !c[i] && (t[i] = e[i], c[i] = !0);
            e = n !== !1 && te(e);
        }while (e && (!n || n(e, t)) && e !== Object.prototype);
        return t;
    }, Ot = (e, t, n)=>{
        e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
        const r = e.indexOf(t, n);
        return r !== -1 && r === n;
    }, Tt = (e)=>{
        if (!e) return null;
        if (B(e)) return e;
        let t = e.length;
        if (!ye(t)) return null;
        const n = new Array(t);
        for(; t-- > 0;)n[t] = e[t];
        return n;
    }, At = ((e)=>(t)=>e && t instanceof e)(typeof Uint8Array < "u" && te(Uint8Array)), xt = (e, t)=>{
        const r = (e && e[Symbol.iterator]).call(e);
        let s;
        for(; (s = r.next()) && !s.done;){
            const o = s.value;
            t.call(e, o[0], o[1]);
        }
    }, Ct = (e, t)=>{
        let n;
        const r = [];
        for(; (n = e.exec(t)) !== null;)r.push(n);
        return r;
    }, Nt = C("HTMLFormElement"), Pt = (e)=>e.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function(n, r, s) {
            return r.toUpperCase() + s;
        }), ge = (({ hasOwnProperty: e })=>(t, n)=>e.call(t, n))(Object.prototype), Lt = C("RegExp"), Ee = (e, t)=>{
        const n = Object.getOwnPropertyDescriptors(e), r = {};
        H(n, (s, o)=>{
            let i;
            (i = t(s, o, e)) !== !1 && (r[o] = i || s);
        }), Object.defineProperties(e, r);
    }, _t = (e)=>{
        Ee(e, (t, n)=>{
            if (x(e) && [
                "arguments",
                "caller",
                "callee"
            ].indexOf(n) !== -1) return !1;
            const r = e[n];
            if (x(r)) {
                if (t.enumerable = !1, "writable" in t) {
                    t.writable = !1;
                    return;
                }
                t.set || (t.set = ()=>{
                    throw Error("Can not rewrite read-only method '" + n + "'");
                });
            }
        });
    }, Ft = (e, t)=>{
        const n = {}, r = (s)=>{
            s.forEach((o)=>{
                n[o] = !0;
            });
        };
        return B(e) ? r(e) : r(String(e).split(t)), n;
    }, Ut = ()=>{}, Dt = (e, t)=>e != null && Number.isFinite(e = +e) ? e : t;
    function Bt(e) {
        return !!(e && x(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
    }
    const kt = (e)=>{
        const t = new Array(10), n = (r, s)=>{
            if ($(r)) {
                if (t.indexOf(r) >= 0) return;
                if (!("toJSON" in r)) {
                    t[s] = r;
                    const o = B(r) ? [] : {};
                    return H(r, (i, c)=>{
                        const f = n(i, s + 1);
                        !q(f) && (o[c] = f);
                    }), t[s] = void 0, o;
                }
            }
            return r;
        };
        return n(e, 0);
    }, jt = C("AsyncFunction"), qt = (e)=>e && ($(e) || x(e)) && x(e.then) && x(e.catch), Re = ((e, t)=>e ? setImmediate : t ? ((n, r)=>(_.addEventListener("message", ({ source: s, data: o })=>{
                s === _ && o === n && r.length && r.shift()();
            }, !1), (s)=>{
                r.push(s), _.postMessage(n, "*");
            }))(`axios@${Math.random()}`, []) : (n)=>setTimeout(n))(typeof setImmediate == "function", x(_.postMessage)), Ht = typeof queueMicrotask < "u" ? queueMicrotask.bind(_) : typeof $fdfecf3dc192a989$exports < "u" && $fdfecf3dc192a989$exports.nextTick || Re, a = {
        isArray: B,
        isArrayBuffer: me,
        isBuffer: rt,
        isFormData: dt,
        isArrayBufferView: st,
        isString: ot,
        isNumber: ye,
        isBoolean: it,
        isObject: $,
        isPlainObject: v,
        isReadableStream: ht,
        isRequest: mt,
        isResponse: yt,
        isHeaders: bt,
        isUndefined: q,
        isDate: at,
        isFile: ct,
        isBlob: ut,
        isRegExp: Lt,
        isFunction: x,
        isStream: ft,
        isURLSearchParams: pt,
        isTypedArray: At,
        isFileList: lt,
        forEach: H,
        merge: ne,
        extend: gt,
        trim: wt,
        stripBOM: Et,
        inherits: Rt,
        toFlatObject: St,
        kindOf: J,
        kindOfTest: C,
        endsWith: Ot,
        toArray: Tt,
        forEachEntry: xt,
        matchAll: Ct,
        isHTMLForm: Nt,
        hasOwnProperty: ge,
        hasOwnProp: ge,
        reduceDescriptors: Ee,
        freezeMethods: _t,
        toObjectSet: Ft,
        toCamelCase: Pt,
        noop: Ut,
        toFiniteNumber: Dt,
        findKey: be,
        global: _,
        isContextDefined: we,
        isSpecCompliantForm: Bt,
        toJSONObject: kt,
        isAsyncFn: jt,
        isThenable: qt,
        setImmediate: Re,
        asap: Ht
    };
    function m(e, t, n, r, s) {
        Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), n && (this.config = n), r && (this.request = r), s && (this.response = s, this.status = s.status ? s.status : null);
    }
    a.inherits(m, Error, {
        toJSON: function() {
            return {
                message: this.message,
                name: this.name,
                description: this.description,
                number: this.number,
                fileName: this.fileName,
                lineNumber: this.lineNumber,
                columnNumber: this.columnNumber,
                stack: this.stack,
                config: a.toJSONObject(this.config),
                code: this.code,
                status: this.status
            };
        }
    });
    const Se = m.prototype, Oe = {};
    [
        "ERR_BAD_OPTION_VALUE",
        "ERR_BAD_OPTION",
        "ECONNABORTED",
        "ETIMEDOUT",
        "ERR_NETWORK",
        "ERR_FR_TOO_MANY_REDIRECTS",
        "ERR_DEPRECATED",
        "ERR_BAD_RESPONSE",
        "ERR_BAD_REQUEST",
        "ERR_CANCELED",
        "ERR_NOT_SUPPORT",
        "ERR_INVALID_URL"
    ].forEach((e)=>{
        Oe[e] = {
            value: e
        };
    }), Object.defineProperties(m, Oe), Object.defineProperty(Se, "isAxiosError", {
        value: !0
    }), m.from = (e, t, n, r, s, o)=>{
        const i = Object.create(Se);
        return a.toFlatObject(e, i, function(f) {
            return f !== Error.prototype;
        }, (c)=>c !== "isAxiosError"), m.call(i, e.message, t, n, r, s), i.cause = e, i.name = e.name, o && Object.assign(i, o), i;
    };
    const It = null;
    function re(e) {
        return a.isPlainObject(e) || a.isArray(e);
    }
    function Te(e) {
        return a.endsWith(e, "[]") ? e.slice(0, -2) : e;
    }
    function Ae(e, t, n) {
        return e ? e.concat(t).map(function(s, o) {
            return s = Te(s), !n && o ? "[" + s + "]" : s;
        }).join(n ? "." : "") : t;
    }
    function Mt(e) {
        return a.isArray(e) && !e.some(re);
    }
    const zt = a.toFlatObject(a, {}, null, function(t) {
        return /^is[A-Z]/.test(t);
    });
    function V(e, t, n) {
        if (!a.isObject(e)) throw new TypeError("target must be an object");
        t = t || new FormData, n = a.toFlatObject(n, {
            metaTokens: !0,
            dots: !1,
            indexes: !1
        }, !1, function(y, h) {
            return !a.isUndefined(h[y]);
        });
        const r = n.metaTokens, s = n.visitor || l, o = n.dots, i = n.indexes, f = (n.Blob || typeof Blob < "u" && Blob) && a.isSpecCompliantForm(t);
        if (!a.isFunction(s)) throw new TypeError("visitor must be a function");
        function u(p) {
            if (p === null) return "";
            if (a.isDate(p)) return p.toISOString();
            if (!f && a.isBlob(p)) throw new m("Blob is not supported. Use a Buffer instead.");
            return a.isArrayBuffer(p) || a.isTypedArray(p) ? f && typeof Blob == "function" ? new Blob([
                p
            ]) : $30f48e7c7d6109f3$require$Buffer.from(p) : p;
        }
        function l(p, y, h) {
            let w = p;
            if (p && !h && typeof p == "object") {
                if (a.endsWith(y, "{}")) y = r ? y : y.slice(0, -2), p = JSON.stringify(p);
                else if (a.isArray(p) && Mt(p) || (a.isFileList(p) || a.endsWith(y, "[]")) && (w = a.toArray(p))) return y = Te(y), w.forEach(function(S, P) {
                    !(a.isUndefined(S) || S === null) && t.append(i === !0 ? Ae([
                        y
                    ], P, o) : i === null ? y : y + "[]", u(S));
                }), !1;
            }
            return re(p) ? !0 : (t.append(Ae(h, y, o), u(p)), !1);
        }
        const d = [], b = Object.assign(zt, {
            defaultVisitor: l,
            convertValue: u,
            isVisitable: re
        });
        function E(p, y) {
            if (!a.isUndefined(p)) {
                if (d.indexOf(p) !== -1) throw Error("Circular reference detected in " + y.join("."));
                d.push(p), a.forEach(p, function(w, R) {
                    (!(a.isUndefined(w) || w === null) && s.call(t, w, a.isString(R) ? R.trim() : R, y, b)) === !0 && E(w, y ? y.concat(R) : [
                        R
                    ]);
                }), d.pop();
            }
        }
        if (!a.isObject(e)) throw new TypeError("data must be an object");
        return E(e), t;
    }
    function xe(e) {
        const t = {
            "!": "%21",
            "'": "%27",
            "(": "%28",
            ")": "%29",
            "~": "%7E",
            "%20": "+",
            "%00": "\0"
        };
        return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(r) {
            return t[r];
        });
    }
    function se(e, t) {
        this._pairs = [], e && V(e, this, t);
    }
    const Ce = se.prototype;
    Ce.append = function(t, n) {
        this._pairs.push([
            t,
            n
        ]);
    }, Ce.toString = function(t) {
        const n = t ? function(r) {
            return t.call(this, r, xe);
        } : xe;
        return this._pairs.map(function(s) {
            return n(s[0]) + "=" + n(s[1]);
        }, "").join("&");
    };
    function Jt(e) {
        return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
    }
    function Ne(e, t, n) {
        if (!t) return e;
        const r = n && n.encode || Jt;
        a.isFunction(n) && (n = {
            serialize: n
        });
        const s = n && n.serialize;
        let o;
        if (s ? o = s(t, n) : o = a.isURLSearchParams(t) ? t.toString() : new se(t, n).toString(r), o) {
            const i = e.indexOf("#");
            i !== -1 && (e = e.slice(0, i)), e += (e.indexOf("?") === -1 ? "?" : "&") + o;
        }
        return e;
    }
    class Pe {
        use(t, n, r) {
            return this.handlers.push({
                fulfilled: t,
                rejected: n,
                synchronous: r ? r.synchronous : !1,
                runWhen: r ? r.runWhen : null
            }), this.handlers.length - 1;
        }
        eject(t) {
            this.handlers[t] && (this.handlers[t] = null);
        }
        clear() {
            this.handlers && (this.handlers = []);
        }
        forEach(t) {
            a.forEach(this.handlers, function(r) {
                r !== null && t(r);
            });
        }
        constructor(){
            this.handlers = [];
        }
    }
    const Le = {
        silentJSONParsing: !0,
        forcedJSONParsing: !0,
        clarifyTimeoutError: !1
    }, Wt = {
        isBrowser: !0,
        classes: {
            URLSearchParams: typeof URLSearchParams < "u" ? URLSearchParams : se,
            FormData: typeof FormData < "u" ? FormData : null,
            Blob: typeof Blob < "u" ? Blob : null
        },
        protocols: [
            "http",
            "https",
            "file",
            "blob",
            "url",
            "data"
        ]
    }, oe = typeof window < "u" && typeof document < "u", ie = typeof navigator == "object" && navigator || void 0, $t = oe && (!ie || [
        "ReactNative",
        "NativeScript",
        "NS"
    ].indexOf(ie.product) < 0), vt = typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope && typeof self.importScripts == "function", Vt = oe && window.location.href || "http://localhost", O = {
        ...Object.freeze(Object.defineProperty({
            __proto__: null,
            hasBrowserEnv: oe,
            hasStandardBrowserEnv: $t,
            hasStandardBrowserWebWorkerEnv: vt,
            navigator: ie,
            origin: Vt
        }, Symbol.toStringTag, {
            value: "Module"
        })),
        ...Wt
    };
    function Kt(e, t) {
        return V(e, new O.classes.URLSearchParams, Object.assign({
            visitor: function(n, r, s, o) {
                return O.isNode && a.isBuffer(n) ? (this.append(r, n.toString("base64")), !1) : o.defaultVisitor.apply(this, arguments);
            }
        }, t));
    }
    function Xt(e) {
        return a.matchAll(/\w+|\[(\w*)]/g, e).map((t)=>t[0] === "[]" ? "" : t[1] || t[0]);
    }
    function Gt(e) {
        const t = {}, n = Object.keys(e);
        let r;
        const s = n.length;
        let o;
        for(r = 0; r < s; r++)o = n[r], t[o] = e[o];
        return t;
    }
    function _e(e) {
        function t(n, r, s, o) {
            let i = n[o++];
            if (i === "__proto__") return !0;
            const c = Number.isFinite(+i), f = o >= n.length;
            return i = !i && a.isArray(s) ? s.length : i, f ? (a.hasOwnProp(s, i) ? s[i] = [
                s[i],
                r
            ] : s[i] = r, !c) : ((!s[i] || !a.isObject(s[i])) && (s[i] = []), t(n, r, s[i], o) && a.isArray(s[i]) && (s[i] = Gt(s[i])), !c);
        }
        if (a.isFormData(e) && a.isFunction(e.entries)) {
            const n = {};
            return a.forEachEntry(e, (r, s)=>{
                t(Xt(r), s, n, 0);
            }), n;
        }
        return null;
    }
    function Qt(e, t, n) {
        if (a.isString(e)) try {
            return (t || JSON.parse)(e), a.trim(e);
        } catch (r) {
            if (r.name !== "SyntaxError") throw r;
        }
        return (n || JSON.stringify)(e);
    }
    const I = {
        transitional: Le,
        adapter: [
            "xhr",
            "http",
            "fetch"
        ],
        transformRequest: [
            function(t, n) {
                const r = n.getContentType() || "", s = r.indexOf("application/json") > -1, o = a.isObject(t);
                if (o && a.isHTMLForm(t) && (t = new FormData(t)), a.isFormData(t)) return s ? JSON.stringify(_e(t)) : t;
                if (a.isArrayBuffer(t) || a.isBuffer(t) || a.isStream(t) || a.isFile(t) || a.isBlob(t) || a.isReadableStream(t)) return t;
                if (a.isArrayBufferView(t)) return t.buffer;
                if (a.isURLSearchParams(t)) return n.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
                let c;
                if (o) {
                    if (r.indexOf("application/x-www-form-urlencoded") > -1) return Kt(t, this.formSerializer).toString();
                    if ((c = a.isFileList(t)) || r.indexOf("multipart/form-data") > -1) {
                        const f = this.env && this.env.FormData;
                        return V(c ? {
                            "files[]": t
                        } : t, f && new f, this.formSerializer);
                    }
                }
                return o || s ? (n.setContentType("application/json", !1), Qt(t)) : t;
            }
        ],
        transformResponse: [
            function(t) {
                const n = this.transitional || I.transitional, r = n && n.forcedJSONParsing, s = this.responseType === "json";
                if (a.isResponse(t) || a.isReadableStream(t)) return t;
                if (t && a.isString(t) && (r && !this.responseType || s)) {
                    const i = !(n && n.silentJSONParsing) && s;
                    try {
                        return JSON.parse(t);
                    } catch (c) {
                        if (i) throw c.name === "SyntaxError" ? m.from(c, m.ERR_BAD_RESPONSE, this, null, this.response) : c;
                    }
                }
                return t;
            }
        ],
        timeout: 0,
        xsrfCookieName: "XSRF-TOKEN",
        xsrfHeaderName: "X-XSRF-TOKEN",
        maxContentLength: -1,
        maxBodyLength: -1,
        env: {
            FormData: O.classes.FormData,
            Blob: O.classes.Blob
        },
        validateStatus: function(t) {
            return t >= 200 && t < 300;
        },
        headers: {
            common: {
                Accept: "application/json, text/plain, */*",
                "Content-Type": void 0
            }
        }
    };
    a.forEach([
        "delete",
        "get",
        "head",
        "post",
        "put",
        "patch"
    ], (e)=>{
        I.headers[e] = {};
    });
    const Zt = a.toObjectSet([
        "age",
        "authorization",
        "content-length",
        "content-type",
        "etag",
        "expires",
        "from",
        "host",
        "if-modified-since",
        "if-unmodified-since",
        "last-modified",
        "location",
        "max-forwards",
        "proxy-authorization",
        "referer",
        "retry-after",
        "user-agent"
    ]), Yt = (e)=>{
        const t = {};
        let n, r, s;
        return e && e.split(`
`).forEach(function(i) {
            s = i.indexOf(":"), n = i.substring(0, s).trim().toLowerCase(), r = i.substring(s + 1).trim(), !(!n || t[n] && Zt[n]) && (n === "set-cookie" ? t[n] ? t[n].push(r) : t[n] = [
                r
            ] : t[n] = t[n] ? t[n] + ", " + r : r);
        }), t;
    }, Fe = Symbol("internals");
    function M(e) {
        return e && String(e).trim().toLowerCase();
    }
    function K(e) {
        return e === !1 || e == null ? e : a.isArray(e) ? e.map(K) : String(e);
    }
    function en(e) {
        const t = Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
        let r;
        for(; r = n.exec(e);)t[r[1]] = r[2];
        return t;
    }
    const tn = (e)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
    function ae(e, t, n, r, s) {
        if (a.isFunction(r)) return r.call(this, t, n);
        if (s && (t = n), !!a.isString(t)) {
            if (a.isString(r)) return t.indexOf(r) !== -1;
            if (a.isRegExp(r)) return r.test(t);
        }
    }
    function nn(e) {
        return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, n, r)=>n.toUpperCase() + r);
    }
    function rn(e, t) {
        const n = a.toCamelCase(" " + t);
        [
            "get",
            "set",
            "has"
        ].forEach((r)=>{
            Object.defineProperty(e, r + n, {
                value: function(s, o, i) {
                    return this[r].call(this, t, s, o, i);
                },
                configurable: !0
            });
        });
    }
    class T {
        set(t, n, r) {
            const s = this;
            function o(c, f, u) {
                const l = M(f);
                if (!l) throw new Error("header name must be a non-empty string");
                const d = a.findKey(s, l);
                (!d || s[d] === void 0 || u === !0 || u === void 0 && s[d] !== !1) && (s[d || f] = K(c));
            }
            const i = (c, f)=>a.forEach(c, (u, l)=>o(u, l, f));
            if (a.isPlainObject(t) || t instanceof this.constructor) i(t, n);
            else if (a.isString(t) && (t = t.trim()) && !tn(t)) i(Yt(t), n);
            else if (a.isHeaders(t)) for (const [c, f] of t.entries())o(f, c, r);
            else t != null && o(n, t, r);
            return this;
        }
        get(t, n) {
            if (t = M(t), t) {
                const r = a.findKey(this, t);
                if (r) {
                    const s = this[r];
                    if (!n) return s;
                    if (n === !0) return en(s);
                    if (a.isFunction(n)) return n.call(this, s, r);
                    if (a.isRegExp(n)) return n.exec(s);
                    throw new TypeError("parser must be boolean|regexp|function");
                }
            }
        }
        has(t, n) {
            if (t = M(t), t) {
                const r = a.findKey(this, t);
                return !!(r && this[r] !== void 0 && (!n || ae(this, this[r], r, n)));
            }
            return !1;
        }
        delete(t, n) {
            const r = this;
            let s = !1;
            function o(i) {
                if (i = M(i), i) {
                    const c = a.findKey(r, i);
                    c && (!n || ae(r, r[c], c, n)) && (delete r[c], s = !0);
                }
            }
            return a.isArray(t) ? t.forEach(o) : o(t), s;
        }
        clear(t) {
            const n = Object.keys(this);
            let r = n.length, s = !1;
            for(; r--;){
                const o = n[r];
                (!t || ae(this, this[o], o, t, !0)) && (delete this[o], s = !0);
            }
            return s;
        }
        normalize(t) {
            const n = this, r = {};
            return a.forEach(this, (s, o)=>{
                const i = a.findKey(r, o);
                if (i) {
                    n[i] = K(s), delete n[o];
                    return;
                }
                const c = t ? nn(o) : String(o).trim();
                c !== o && delete n[o], n[c] = K(s), r[c] = !0;
            }), this;
        }
        concat(...t) {
            return this.constructor.concat(this, ...t);
        }
        toJSON(t) {
            const n = Object.create(null);
            return a.forEach(this, (r, s)=>{
                r != null && r !== !1 && (n[s] = t && a.isArray(r) ? r.join(", ") : r);
            }), n;
        }
        [Symbol.iterator]() {
            return Object.entries(this.toJSON())[Symbol.iterator]();
        }
        toString() {
            return Object.entries(this.toJSON()).map(([t, n])=>t + ": " + n).join(`
`);
        }
        get [Symbol.toStringTag]() {
            return "AxiosHeaders";
        }
        static from(t) {
            return t instanceof this ? t : new this(t);
        }
        static concat(t, ...n) {
            const r = new this(t);
            return n.forEach((s)=>r.set(s)), r;
        }
        static accessor(t) {
            const r = (this[Fe] = this[Fe] = {
                accessors: {}
            }).accessors, s = this.prototype;
            function o(i) {
                const c = M(i);
                r[c] || (rn(s, i), r[c] = !0);
            }
            return a.isArray(t) ? t.forEach(o) : o(t), this;
        }
        constructor(t){
            t && this.set(t);
        }
    }
    T.accessor([
        "Content-Type",
        "Content-Length",
        "Accept",
        "Accept-Encoding",
        "User-Agent",
        "Authorization"
    ]), a.reduceDescriptors(T.prototype, ({ value: e }, t)=>{
        let n = t[0].toUpperCase() + t.slice(1);
        return {
            get: ()=>e,
            set (r) {
                this[n] = r;
            }
        };
    }), a.freezeMethods(T);
    function ce(e, t) {
        const n = this || I, r = t || n, s = T.from(r.headers);
        let o = r.data;
        return a.forEach(e, function(c) {
            o = c.call(n, o, s.normalize(), t ? t.status : void 0);
        }), s.normalize(), o;
    }
    function Ue(e) {
        return !!(e && e.__CANCEL__);
    }
    function k(e, t, n) {
        m.call(this, e !== null && e !== void 0 ? e : "canceled", m.ERR_CANCELED, t, n), this.name = "CanceledError";
    }
    a.inherits(k, m, {
        __CANCEL__: !0
    });
    function De(e, t, n) {
        const r = n.config.validateStatus;
        !n.status || !r || r(n.status) ? e(n) : t(new m("Request failed with status code " + n.status, [
            m.ERR_BAD_REQUEST,
            m.ERR_BAD_RESPONSE
        ][Math.floor(n.status / 100) - 4], n.config, n.request, n));
    }
    function sn(e) {
        const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
        return t && t[1] || "";
    }
    function on(e, t) {
        e = e || 10;
        const n = new Array(e), r = new Array(e);
        let s = 0, o = 0, i;
        return t = t !== void 0 ? t : 1e3, function(f) {
            const u = Date.now(), l = r[o];
            i || (i = u), n[s] = f, r[s] = u;
            let d = o, b = 0;
            for(; d !== s;)b += n[d++], d = d % e;
            if (s = (s + 1) % e, s === o && (o = (o + 1) % e), u - i < t) return;
            const E = l && u - l;
            return E ? Math.round(b * 1e3 / E) : void 0;
        };
    }
    function an(e, t) {
        let n = 0, r = 1e3 / t, s, o;
        const i = (u, l = Date.now())=>{
            n = l, s = null, o && (clearTimeout(o), o = null), e.apply(null, u);
        };
        return [
            (...u)=>{
                const l = Date.now(), d = l - n;
                d >= r ? i(u, l) : (s = u, o || (o = setTimeout(()=>{
                    o = null, i(s);
                }, r - d)));
            },
            ()=>s && i(s)
        ];
    }
    const X = (e, t, n = 3)=>{
        let r = 0;
        const s = on(50, 250);
        return an((o)=>{
            const i = o.loaded, c = o.lengthComputable ? o.total : void 0, f = i - r, u = s(f), l = i <= c;
            r = i;
            const d = {
                loaded: i,
                total: c,
                progress: c ? i / c : void 0,
                bytes: f,
                rate: u || void 0,
                estimated: u && c && l ? (c - i) / u : void 0,
                event: o,
                lengthComputable: c != null,
                [t ? "download" : "upload"]: !0
            };
            e(d);
        }, n);
    }, Be = (e, t)=>{
        const n = e != null;
        return [
            (r)=>t[0]({
                    lengthComputable: n,
                    total: e,
                    loaded: r
                }),
            t[1]
        ];
    }, ke = (e)=>(...t)=>a.asap(()=>e(...t)), cn = O.hasStandardBrowserEnv ? ((e, t)=>(n)=>(n = new URL(n, O.origin), e.protocol === n.protocol && e.host === n.host && (t || e.port === n.port)))(new URL(O.origin), O.navigator && /(msie|trident)/i.test(O.navigator.userAgent)) : ()=>!0, un = O.hasStandardBrowserEnv ? {
        write (e, t, n, r, s, o) {
            const i = [
                e + "=" + encodeURIComponent(t)
            ];
            a.isNumber(n) && i.push("expires=" + new Date(n).toGMTString()), a.isString(r) && i.push("path=" + r), a.isString(s) && i.push("domain=" + s), o === !0 && i.push("secure"), document.cookie = i.join("; ");
        },
        read (e) {
            const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
            return t ? decodeURIComponent(t[3]) : null;
        },
        remove (e) {
            this.write(e, "", Date.now() - 864e5);
        }
    } : {
        write () {},
        read () {
            return null;
        },
        remove () {}
    };
    function ln(e) {
        return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
    }
    function fn(e, t) {
        return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
    }
    function je(e, t, n) {
        let r = !ln(t);
        return e && r || n == !1 ? fn(e, t) : t;
    }
    const qe = (e)=>e instanceof T ? {
            ...e
        } : e;
    function F(e, t) {
        t = t || {};
        const n = {};
        function r(u, l, d, b) {
            return a.isPlainObject(u) && a.isPlainObject(l) ? a.merge.call({
                caseless: b
            }, u, l) : a.isPlainObject(l) ? a.merge({}, l) : a.isArray(l) ? l.slice() : l;
        }
        function s(u, l, d, b) {
            if (a.isUndefined(l)) {
                if (!a.isUndefined(u)) return r(void 0, u, d, b);
            } else return r(u, l, d, b);
        }
        function o(u, l) {
            if (!a.isUndefined(l)) return r(void 0, l);
        }
        function i(u, l) {
            if (a.isUndefined(l)) {
                if (!a.isUndefined(u)) return r(void 0, u);
            } else return r(void 0, l);
        }
        function c(u, l, d) {
            if (d in t) return r(u, l);
            if (d in e) return r(void 0, u);
        }
        const f = {
            url: o,
            method: o,
            data: o,
            baseURL: i,
            transformRequest: i,
            transformResponse: i,
            paramsSerializer: i,
            timeout: i,
            timeoutMessage: i,
            withCredentials: i,
            withXSRFToken: i,
            adapter: i,
            responseType: i,
            xsrfCookieName: i,
            xsrfHeaderName: i,
            onUploadProgress: i,
            onDownloadProgress: i,
            decompress: i,
            maxContentLength: i,
            maxBodyLength: i,
            beforeRedirect: i,
            transport: i,
            httpAgent: i,
            httpsAgent: i,
            cancelToken: i,
            socketPath: i,
            responseEncoding: i,
            validateStatus: c,
            headers: (u, l, d)=>s(qe(u), qe(l), d, !0)
        };
        return a.forEach(Object.keys(Object.assign({}, e, t)), function(l) {
            const d = f[l] || s, b = d(e[l], t[l], l);
            a.isUndefined(b) && d !== c || (n[l] = b);
        }), n;
    }
    const He = (e)=>{
        const t = F({}, e);
        let { data: n, withXSRFToken: r, xsrfHeaderName: s, xsrfCookieName: o, headers: i, auth: c } = t;
        t.headers = i = T.from(i), t.url = Ne(je(t.baseURL, t.url, t.allowAbsoluteUrls), e.params, e.paramsSerializer), c && i.set("Authorization", "Basic " + btoa((c.username || "") + ":" + (c.password ? unescape(encodeURIComponent(c.password)) : "")));
        let f;
        if (a.isFormData(n)) {
            if (O.hasStandardBrowserEnv || O.hasStandardBrowserWebWorkerEnv) i.setContentType(void 0);
            else if ((f = i.getContentType()) !== !1) {
                const [u, ...l] = f ? f.split(";").map((d)=>d.trim()).filter(Boolean) : [];
                i.setContentType([
                    u || "multipart/form-data",
                    ...l
                ].join("; "));
            }
        }
        if (O.hasStandardBrowserEnv && (r && a.isFunction(r) && (r = r(t)), r || r !== !1 && cn(t.url))) {
            const u = s && o && un.read(o);
            u && i.set(s, u);
        }
        return t;
    }, dn = typeof XMLHttpRequest < "u" && function(e) {
        return new Promise(function(n, r) {
            const s = He(e);
            let o = s.data;
            const i = T.from(s.headers).normalize();
            let { responseType: c, onUploadProgress: f, onDownloadProgress: u } = s, l, d, b, E, p;
            function y() {
                E && E(), p && p(), s.cancelToken && s.cancelToken.unsubscribe(l), s.signal && s.signal.removeEventListener("abort", l);
            }
            let h = new XMLHttpRequest;
            h.open(s.method.toUpperCase(), s.url, !0), h.timeout = s.timeout;
            function w() {
                if (!h) return;
                const S = T.from("getAllResponseHeaders" in h && h.getAllResponseHeaders()), A = {
                    data: !c || c === "text" || c === "json" ? h.responseText : h.response,
                    status: h.status,
                    statusText: h.statusText,
                    headers: S,
                    config: e,
                    request: h
                };
                De(function(D) {
                    n(D), y();
                }, function(D) {
                    r(D), y();
                }, A), h = null;
            }
            "onloadend" in h ? h.onloadend = w : h.onreadystatechange = function() {
                !h || h.readyState !== 4 || h.status === 0 && !(h.responseURL && h.responseURL.indexOf("file:") === 0) || setTimeout(w);
            }, h.onabort = function() {
                h && (r(new m("Request aborted", m.ECONNABORTED, e, h)), h = null);
            }, h.onerror = function() {
                r(new m("Network Error", m.ERR_NETWORK, e, h)), h = null;
            }, h.ontimeout = function() {
                let P = s.timeout ? "timeout of " + s.timeout + "ms exceeded" : "timeout exceeded";
                const A = s.transitional || Le;
                s.timeoutErrorMessage && (P = s.timeoutErrorMessage), r(new m(P, A.clarifyTimeoutError ? m.ETIMEDOUT : m.ECONNABORTED, e, h)), h = null;
            }, o === void 0 && i.setContentType(null), "setRequestHeader" in h && a.forEach(i.toJSON(), function(P, A) {
                h.setRequestHeader(A, P);
            }), a.isUndefined(s.withCredentials) || (h.withCredentials = !!s.withCredentials), c && c !== "json" && (h.responseType = s.responseType), u && ([b, p] = X(u, !0), h.addEventListener("progress", b)), f && h.upload && ([d, E] = X(f), h.upload.addEventListener("progress", d), h.upload.addEventListener("loadend", E)), (s.cancelToken || s.signal) && (l = (S)=>{
                h && (r(!S || S.type ? new k(null, e, h) : S), h.abort(), h = null);
            }, s.cancelToken && s.cancelToken.subscribe(l), s.signal && (s.signal.aborted ? l() : s.signal.addEventListener("abort", l)));
            const R = sn(s.url);
            if (R && O.protocols.indexOf(R) === -1) {
                r(new m("Unsupported protocol " + R + ":", m.ERR_BAD_REQUEST, e));
                return;
            }
            h.send(o || null);
        });
    }, pn = (e, t)=>{
        const { length: n } = e = e ? e.filter(Boolean) : [];
        if (t || n) {
            let r = new AbortController, s;
            const o = function(u) {
                if (!s) {
                    s = !0, c();
                    const l = u instanceof Error ? u : this.reason;
                    r.abort(l instanceof m ? l : new k(l instanceof Error ? l.message : l));
                }
            };
            let i = t && setTimeout(()=>{
                i = null, o(new m(`timeout ${t} of ms exceeded`, m.ETIMEDOUT));
            }, t);
            const c = ()=>{
                e && (i && clearTimeout(i), i = null, e.forEach((u)=>{
                    u.unsubscribe ? u.unsubscribe(o) : u.removeEventListener("abort", o);
                }), e = null);
            };
            e.forEach((u)=>u.addEventListener("abort", o));
            const { signal: f } = r;
            return f.unsubscribe = ()=>a.asap(c), f;
        }
    }, hn = function*(e, t) {
        let n = e.byteLength;
        if (!t || n < t) {
            yield e;
            return;
        }
        let r = 0, s;
        for(; r < n;)s = r + t, yield e.slice(r, s), r = s;
    }, mn = async function*(e, t) {
        for await (const n of yn(e))yield* hn(n, t);
    }, yn = async function*(e) {
        if (e[Symbol.asyncIterator]) {
            yield* e;
            return;
        }
        const t = e.getReader();
        try {
            for(;;){
                const { done: n, value: r } = await t.read();
                if (n) break;
                yield r;
            }
        } finally{
            await t.cancel();
        }
    }, Ie = (e, t, n, r)=>{
        const s = mn(e, t);
        let o = 0, i, c = (f)=>{
            i || (i = !0, r && r(f));
        };
        return new ReadableStream({
            async pull (f) {
                try {
                    const { done: u, value: l } = await s.next();
                    if (u) {
                        c(), f.close();
                        return;
                    }
                    let d = l.byteLength;
                    if (n) {
                        let b = o += d;
                        n(b);
                    }
                    f.enqueue(new Uint8Array(l));
                } catch (u) {
                    throw c(u), u;
                }
            },
            cancel (f) {
                return c(f), s.return();
            }
        }, {
            highWaterMark: 2
        });
    }, G = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", Me = G && typeof ReadableStream == "function", bn = G && (typeof TextEncoder == "function" ? ((e)=>(t)=>e.encode(t))(new TextEncoder) : async (e)=>new Uint8Array(await new Response(e).arrayBuffer())), ze = (e, ...t)=>{
        try {
            return !!e(...t);
        } catch  {
            return !1;
        }
    }, wn = Me && ze(()=>{
        let e = !1;
        const t = new Request(O.origin, {
            body: new ReadableStream,
            method: "POST",
            get duplex () {
                return e = !0, "half";
            }
        }).headers.has("Content-Type");
        return e && !t;
    }), Je = 65536, ue = Me && ze(()=>a.isReadableStream(new Response("").body)), Q = {
        stream: ue && ((e)=>e.body)
    };
    G && ((e)=>{
        [
            "text",
            "arrayBuffer",
            "blob",
            "formData",
            "stream"
        ].forEach((t)=>{
            !Q[t] && (Q[t] = a.isFunction(e[t]) ? (n)=>n[t]() : (n, r)=>{
                throw new m(`Response type '${t}' is not supported`, m.ERR_NOT_SUPPORT, r);
            });
        });
    })(new Response);
    const gn = async (e)=>{
        if (e == null) return 0;
        if (a.isBlob(e)) return e.size;
        if (a.isSpecCompliantForm(e)) return (await new Request(O.origin, {
            method: "POST",
            body: e
        }).arrayBuffer()).byteLength;
        if (a.isArrayBufferView(e) || a.isArrayBuffer(e)) return e.byteLength;
        if (a.isURLSearchParams(e) && (e = e + ""), a.isString(e)) return (await bn(e)).byteLength;
    }, En = async (e, t)=>{
        const n = a.toFiniteNumber(e.getContentLength());
        return n !== null && n !== void 0 ? n : gn(t);
    }, le = {
        http: It,
        xhr: dn,
        fetch: G && (async (e)=>{
            let { url: t, method: n, data: r, signal: s, cancelToken: o, timeout: i, onDownloadProgress: c, onUploadProgress: f, responseType: u, headers: l, withCredentials: d = "same-origin", fetchOptions: b } = He(e);
            u = u ? (u + "").toLowerCase() : "text";
            let E = pn([
                s,
                o && o.toAbortSignal()
            ], i), p;
            const y = E && E.unsubscribe && (()=>{
                E.unsubscribe();
            });
            let h;
            try {
                if (f && wn && n !== "get" && n !== "head" && (h = await En(l, r)) !== 0) {
                    let A = new Request(t, {
                        method: "POST",
                        body: r,
                        duplex: "half"
                    }), L;
                    if (a.isFormData(r) && (L = A.headers.get("content-type")) && l.setContentType(L), A.body) {
                        const [D, ee] = Be(h, X(ke(f)));
                        r = Ie(A.body, Je, D, ee);
                    }
                }
                a.isString(d) || (d = d ? "include" : "omit");
                const w = "credentials" in Request.prototype;
                p = new Request(t, {
                    ...b,
                    signal: E,
                    method: n.toUpperCase(),
                    headers: l.normalize().toJSON(),
                    body: r,
                    duplex: "half",
                    credentials: w ? d : void 0
                });
                let R = await fetch(p);
                const S = ue && (u === "stream" || u === "response");
                if (ue && (c || S && y)) {
                    const A = {};
                    [
                        "status",
                        "statusText",
                        "headers"
                    ].forEach((Ye)=>{
                        A[Ye] = R[Ye];
                    });
                    const L = a.toFiniteNumber(R.headers.get("content-length")), [D, ee] = c && Be(L, X(ke(c), !0)) || [];
                    R = new Response(Ie(R.body, Je, D, ()=>{
                        ee && ee(), y && y();
                    }), A);
                }
                u = u || "text";
                let P = await Q[a.findKey(Q, u) || "text"](R, e);
                return !S && y && y(), await new Promise((A, L)=>{
                    De(A, L, {
                        data: P,
                        headers: T.from(R.headers),
                        status: R.status,
                        statusText: R.statusText,
                        config: e,
                        request: p
                    });
                });
            } catch (w) {
                throw y && y(), w && w.name === "TypeError" && /fetch/i.test(w.message) ? Object.assign(new m("Network Error", m.ERR_NETWORK, e, p), {
                    cause: w.cause || w
                }) : m.from(w, w && w.code, e, p);
            }
        })
    };
    a.forEach(le, (e, t)=>{
        if (e) {
            try {
                Object.defineProperty(e, "name", {
                    value: t
                });
            } catch  {}
            Object.defineProperty(e, "adapterName", {
                value: t
            });
        }
    });
    const We = (e)=>`- ${e}`, Rn = (e)=>a.isFunction(e) || e === null || e === !1, $e = {
        getAdapter: (e)=>{
            e = a.isArray(e) ? e : [
                e
            ];
            const { length: t } = e;
            let n, r;
            const s = {};
            for(let o = 0; o < t; o++){
                n = e[o];
                let i;
                if (r = n, !Rn(n) && (r = le[(i = String(n)).toLowerCase()], r === void 0)) throw new m(`Unknown adapter '${i}'`);
                if (r) break;
                s[i || "#" + o] = r;
            }
            if (!r) {
                const o = Object.entries(s).map(([c, f])=>`adapter ${c} ` + (f === !1 ? "is not supported by the environment" : "is not available in the build"));
                let i = t ? o.length > 1 ? `since :
` + o.map(We).join(`
`) : " " + We(o[0]) : "as no adapter specified";
                throw new m("There is no suitable adapter to dispatch the request " + i, "ERR_NOT_SUPPORT");
            }
            return r;
        },
        adapters: le
    };
    function fe(e) {
        if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted) throw new k(null, e);
    }
    function ve(e) {
        return fe(e), e.headers = T.from(e.headers), e.data = ce.call(e, e.transformRequest), [
            "post",
            "put",
            "patch"
        ].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), $e.getAdapter(e.adapter || I.adapter)(e).then(function(r) {
            return fe(e), r.data = ce.call(e, e.transformResponse, r), r.headers = T.from(r.headers), r;
        }, function(r) {
            return Ue(r) || (fe(e), r && r.response && (r.response.data = ce.call(e, e.transformResponse, r.response), r.response.headers = T.from(r.response.headers))), Promise.reject(r);
        });
    }
    const Ve = "1.8.3", Z = {};
    [
        "object",
        "boolean",
        "number",
        "function",
        "string",
        "symbol"
    ].forEach((e, t)=>{
        Z[e] = function(r) {
            return typeof r === e || "a" + (t < 1 ? "n " : " ") + e;
        };
    });
    const Ke = {};
    Z.transitional = function(t, n, r) {
        function s(o, i) {
            return "[Axios v" + Ve + "] Transitional option '" + o + "'" + i + (r ? ". " + r : "");
        }
        return (o, i, c)=>{
            if (t === !1) throw new m(s(i, " has been removed" + (n ? " in " + n : "")), m.ERR_DEPRECATED);
            return n && !Ke[i] && (Ke[i] = !0, console.warn(s(i, " has been deprecated since v" + n + " and will be removed in the near future"))), t ? t(o, i, c) : !0;
        };
    }, Z.spelling = function(t) {
        return (n, r)=>(console.warn(`${r} is likely a misspelling of ${t}`), !0);
    };
    function Sn(e, t, n) {
        if (typeof e != "object") throw new m("options must be an object", m.ERR_BAD_OPTION_VALUE);
        const r = Object.keys(e);
        let s = r.length;
        for(; s-- > 0;){
            const o = r[s], i = t[o];
            if (i) {
                const c = e[o], f = c === void 0 || i(c, o, e);
                if (f !== !0) throw new m("option " + o + " must be " + f, m.ERR_BAD_OPTION_VALUE);
                continue;
            }
            if (n !== !0) throw new m("Unknown option " + o, m.ERR_BAD_OPTION);
        }
    }
    const Y = {
        assertOptions: Sn,
        validators: Z
    }, N = Y.validators;
    class U {
        async request(t, n) {
            try {
                return await this._request(t, n);
            } catch (r) {
                if (r instanceof Error) {
                    let s = {};
                    Error.captureStackTrace ? Error.captureStackTrace(s) : s = new Error;
                    const o = s.stack ? s.stack.replace(/^.+\n/, "") : "";
                    try {
                        r.stack ? o && !String(r.stack).endsWith(o.replace(/^.+\n.+\n/, "")) && (r.stack += `
` + o) : r.stack = o;
                    } catch  {}
                }
                throw r;
            }
        }
        _request(t, n) {
            typeof t == "string" ? (n = n || {}, n.url = t) : n = t || {}, n = F(this.defaults, n);
            const { transitional: r, paramsSerializer: s, headers: o } = n;
            r !== void 0 && Y.assertOptions(r, {
                silentJSONParsing: N.transitional(N.boolean),
                forcedJSONParsing: N.transitional(N.boolean),
                clarifyTimeoutError: N.transitional(N.boolean)
            }, !1), s != null && (a.isFunction(s) ? n.paramsSerializer = {
                serialize: s
            } : Y.assertOptions(s, {
                encode: N.function,
                serialize: N.function
            }, !0)), n.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? n.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : n.allowAbsoluteUrls = !0), Y.assertOptions(n, {
                baseUrl: N.spelling("baseURL"),
                withXsrfToken: N.spelling("withXSRFToken")
            }, !0), n.method = (n.method || this.defaults.method || "get").toLowerCase();
            let i = o && a.merge(o.common, o[n.method]);
            o && a.forEach([
                "delete",
                "get",
                "head",
                "post",
                "put",
                "patch",
                "common"
            ], (p)=>{
                delete o[p];
            }), n.headers = T.concat(i, o);
            const c = [];
            let f = !0;
            this.interceptors.request.forEach(function(y) {
                typeof y.runWhen == "function" && y.runWhen(n) === !1 || (f = f && y.synchronous, c.unshift(y.fulfilled, y.rejected));
            });
            const u = [];
            this.interceptors.response.forEach(function(y) {
                u.push(y.fulfilled, y.rejected);
            });
            let l, d = 0, b;
            if (!f) {
                const p = [
                    ve.bind(this),
                    void 0
                ];
                for(p.unshift.apply(p, c), p.push.apply(p, u), b = p.length, l = Promise.resolve(n); d < b;)l = l.then(p[d++], p[d++]);
                return l;
            }
            b = c.length;
            let E = n;
            for(d = 0; d < b;){
                const p = c[d++], y = c[d++];
                try {
                    E = p(E);
                } catch (h) {
                    y.call(this, h);
                    break;
                }
            }
            try {
                l = ve.call(this, E);
            } catch (p) {
                return Promise.reject(p);
            }
            for(d = 0, b = u.length; d < b;)l = l.then(u[d++], u[d++]);
            return l;
        }
        getUri(t) {
            t = F(this.defaults, t);
            const n = je(t.baseURL, t.url, t.allowAbsoluteUrls);
            return Ne(n, t.params, t.paramsSerializer);
        }
        constructor(t){
            this.defaults = t, this.interceptors = {
                request: new Pe,
                response: new Pe
            };
        }
    }
    a.forEach([
        "delete",
        "get",
        "head",
        "options"
    ], function(t) {
        U.prototype[t] = function(n, r) {
            return this.request(F(r || {}, {
                method: t,
                url: n,
                data: (r || {}).data
            }));
        };
    }), a.forEach([
        "post",
        "put",
        "patch"
    ], function(t) {
        function n(r) {
            return function(o, i, c) {
                return this.request(F(c || {}, {
                    method: t,
                    headers: r ? {
                        "Content-Type": "multipart/form-data"
                    } : {},
                    url: o,
                    data: i
                }));
            };
        }
        U.prototype[t] = n(), U.prototype[t + "Form"] = n(!0);
    });
    class de {
        throwIfRequested() {
            if (this.reason) throw this.reason;
        }
        subscribe(t) {
            if (this.reason) {
                t(this.reason);
                return;
            }
            this._listeners ? this._listeners.push(t) : this._listeners = [
                t
            ];
        }
        unsubscribe(t) {
            if (!this._listeners) return;
            const n = this._listeners.indexOf(t);
            n !== -1 && this._listeners.splice(n, 1);
        }
        toAbortSignal() {
            const t = new AbortController, n = (r)=>{
                t.abort(r);
            };
            return this.subscribe(n), t.signal.unsubscribe = ()=>this.unsubscribe(n), t.signal;
        }
        static source() {
            let t;
            return {
                token: new de(function(s) {
                    t = s;
                }),
                cancel: t
            };
        }
        constructor(t){
            if (typeof t != "function") throw new TypeError("executor must be a function.");
            let n;
            this.promise = new Promise(function(o) {
                n = o;
            });
            const r = this;
            this.promise.then((s)=>{
                if (!r._listeners) return;
                let o = r._listeners.length;
                for(; o-- > 0;)r._listeners[o](s);
                r._listeners = null;
            }), this.promise.then = (s)=>{
                let o;
                const i = new Promise((c)=>{
                    r.subscribe(c), o = c;
                }).then(s);
                return i.cancel = function() {
                    r.unsubscribe(o);
                }, i;
            }, t(function(o, i, c) {
                r.reason || (r.reason = new k(o, i, c), n(r.reason));
            });
        }
    }
    function On(e) {
        return function(n) {
            return e.apply(null, n);
        };
    }
    function Tn(e) {
        return a.isObject(e) && e.isAxiosError === !0;
    }
    const pe = {
        Continue: 100,
        SwitchingProtocols: 101,
        Processing: 102,
        EarlyHints: 103,
        Ok: 200,
        Created: 201,
        Accepted: 202,
        NonAuthoritativeInformation: 203,
        NoContent: 204,
        ResetContent: 205,
        PartialContent: 206,
        MultiStatus: 207,
        AlreadyReported: 208,
        ImUsed: 226,
        MultipleChoices: 300,
        MovedPermanently: 301,
        Found: 302,
        SeeOther: 303,
        NotModified: 304,
        UseProxy: 305,
        Unused: 306,
        TemporaryRedirect: 307,
        PermanentRedirect: 308,
        BadRequest: 400,
        Unauthorized: 401,
        PaymentRequired: 402,
        Forbidden: 403,
        NotFound: 404,
        MethodNotAllowed: 405,
        NotAcceptable: 406,
        ProxyAuthenticationRequired: 407,
        RequestTimeout: 408,
        Conflict: 409,
        Gone: 410,
        LengthRequired: 411,
        PreconditionFailed: 412,
        PayloadTooLarge: 413,
        UriTooLong: 414,
        UnsupportedMediaType: 415,
        RangeNotSatisfiable: 416,
        ExpectationFailed: 417,
        ImATeapot: 418,
        MisdirectedRequest: 421,
        UnprocessableEntity: 422,
        Locked: 423,
        FailedDependency: 424,
        TooEarly: 425,
        UpgradeRequired: 426,
        PreconditionRequired: 428,
        TooManyRequests: 429,
        RequestHeaderFieldsTooLarge: 431,
        UnavailableForLegalReasons: 451,
        InternalServerError: 500,
        NotImplemented: 501,
        BadGateway: 502,
        ServiceUnavailable: 503,
        GatewayTimeout: 504,
        HttpVersionNotSupported: 505,
        VariantAlsoNegotiates: 506,
        InsufficientStorage: 507,
        LoopDetected: 508,
        NotExtended: 510,
        NetworkAuthenticationRequired: 511
    };
    Object.entries(pe).forEach(([e, t])=>{
        pe[t] = e;
    });
    function Xe(e) {
        const t = new U(e), n = he(U.prototype.request, t);
        return a.extend(n, U.prototype, t, {
            allOwnKeys: !0
        }), a.extend(n, t, null, {
            allOwnKeys: !0
        }), n.create = function(s) {
            return Xe(F(e, s));
        }, n;
    }
    const g = Xe(I);
    g.Axios = U, g.CanceledError = k, g.CancelToken = de, g.isCancel = Ue, g.VERSION = Ve, g.toFormData = V, g.AxiosError = m, g.Cancel = g.CanceledError, g.all = function(t) {
        return Promise.all(t);
    }, g.spread = On, g.isAxiosError = Tn, g.mergeConfig = F, g.AxiosHeaders = T, g.formToJSON = (e)=>_e(a.isHTMLForm(e) ? new FormData(e) : e), g.getAdapter = $e.getAdapter, g.HttpStatusCode = pe, g.default = g;
    function An() {
        const e = document.querySelector("head base");
        var _ref;
        return (_ref = e == null ? void 0 : e.getAttribute("href")) !== null && _ref !== void 0 ? _ref : "/";
    }
    async function xn(e, t = "GET", n) {
        return await g({
            method: t,
            url: e,
            ...n,
            baseURL: An()
        });
    }
    const Cn = {
        logException: ()=>Promise.resolve(!1)
    };
    async function Ge() {
        async function e(t, n = "Warning", r = "") {
            const s = new Date().toISOString(), o = typeof t == "string" ? t : JSON.stringify(t), i = {
                logLevel: n !== null && n !== void 0 ? n : "Warning",
                text: o,
                stack: r,
                timestamp: s,
                url: window.location.pathname,
                browserLanguage: window.navigator.language || window.navigator.userLanguage || "",
                userAgent: window.navigator.userAgent || "",
                browserVendor: window.navigator.vendor || ""
            };
            try {
                return await xn("/Log/ClientError", "POST", {
                    data: i
                }), !0;
            } catch (c) {
                return console.error("Error logging exception", c), !1;
            }
        }
        return {
            logException: e
        };
    }
    const Qe = new et, z = tt(function(...t) {
        Qe.notify(t);
    }, 100), Nn = 50;
    Ge().then((e)=>{
        const t = {
            count: 0
        };
        window.nepheleErrorLogger = e;
        const n = Qe.subscribe((r)=>{
            t.count++, e.logException(...r).catch(), t.count >= Nn && n.unsubscribe();
        });
    });
    const Ze = [
        "chrome-extension://",
        "moz-extension://"
    ];
    function Pn(e) {
        var r;
        const t = (e == null ? void 0 : e.filename) || "";
        if (Ze.some((s)=>t.startsWith(s))) return !0;
        const n = ((r = e == null ? void 0 : e.error) == null ? void 0 : r.stack) || "";
        return !!Ze.some((s)=>n.startsWith(s));
    }
    return window.addEventListener("error", (e)=>{
        var t;
        var _ref;
        Pn(e) || z(e.message, "Warning", (_ref = (t = e == null ? void 0 : e.error) == null ? void 0 : t.stack) !== null && _ref !== void 0 ? _ref : "");
    }), window.addEventListener("unhandledrejection", (e)=>{
        z(e.reason);
    }), window.addEventListener("securitypolicyviolation", (e)=>{
        const t = {
            blockedURI: e.blockedURI,
            columnNumber: e.columnNumber,
            lineNumber: e.lineNumber,
            documentURI: e.documentURI,
            originalPolicy: e.originalPolicy,
            referrer: e.referrer,
            sourceFile: e.sourceFile,
            statusCode: e.statusCode,
            violatedDirective: e.violatedDirective
        };
        z(t, "Error");
    }), window.addEventListener("DOMException", (e)=>{
        const t = e, n = {
            message: t.message,
            name: t.name
        };
        z(n);
    }), j.NoopLogger = Cn, j.createLogger = Ge, j.logException = z, Object.defineProperty(j, Symbol.toStringTag, {
        value: "Module"
    }), j;
}({});



})();
//# sourceMappingURL=error-logger.js.map
